import { flexRender } from "@tanstack/react-table";

const DataTable = ({ tableInstance, title, centeredColumns = [] }) => {
  if (!tableInstance) return null;

  return (
    <div className="table-wrapper mb-5">
      {title && <h5 className="table-title">{title}</h5>}
      <table className="table" style={{ width: '100%', tableLayout: 'fixed' }}>
        <thead className="table-header">
          {tableInstance.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  style={{
                    width: header.id === 'actions' ? 'auto' : header.getSize(),
                    position: 'relative',
                    cursor: header.column.getCanSort() ? 'pointer' : 'default',
                    borderBottom: '2px solid rgba(0, 123, 255, 0.15)',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    padding: '4px 0'
                  }}
                  onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                >
                  <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '10px' }}>
                    <span style={{ fontSize: '11px' }}>{flexRender(header.column.columnDef.header, header.getContext())}</span>

                    {header.column.getCanSort() && (
                      <div style={{ width: '20px', textAlign: 'left', marginLeft: '5px' }}>
                        {{
                          asc: "🔼",
                          desc: "🔽",
                        }[header.column.getIsSorted()] ?? "↕️"}
                      </div>
                    )}
                  </div>

                  <div
                    onMouseDown={header.getResizeHandler()}
                    onTouchStart={header.getResizeHandler()}
                    className={`resizer ${header.column.getIsResizing() ? 'isResizing' : ''}`}
                  />
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {tableInstance.getRowModel().rows.map((row) => (
            <tr key={row.id} className={row.index % 2 === 0 ? "even" : "odd"}>
              {row.getVisibleCells().map((cell) => {
                const isCentered = centeredColumns.includes(cell.column.id);

                return (
                  <td
                    key={cell.id}
                    className={isCentered ? 'text-center-col' : ''}
                    style={{
                      width: cell.column.getSize(),
                      height: '1px',
                      padding: '8px 4px'
                    }}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Reusable Pagination */}
      <div className="pagination d-flex justify-content-between align-items-center">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => tableInstance.previousPage()}
          disabled={!tableInstance.getCanPreviousPage()}
        >
          Previous
        </button>

        <div className="d-flex align-items-center gap-2">
          <span>Page {tableInstance.getState().pagination.pageIndex + 1} of {tableInstance.getPageCount()}</span>
          <select
            className="form-select form-select-sm"
            style={{ width: 'auto' }}
            value={tableInstance.getState().pagination.pageSize}
            onChange={(e) => tableInstance.setPageSize(Number(e.target.value))}
          >
            {[10, 25, 50].map(size => (
              <option key={size} value={size}>{size} rows</option>
            ))}
          </select>
        </div>

        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => tableInstance.nextPage()}
          disabled={!tableInstance.getCanNextPage()}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default DataTable;